import { useCallback } from 'react'

export function useTrackConversion() {
  const trackConversion = useCallback(
    ({ value = 29, email = '', currency = 'USD' }) => {
      if (typeof window !== 'undefined') {
        const windowObject = window as unknown as any

        windowObject.dataLayer?.push({
          event: 'conversion_event_submit_lead_form',
          value,
          currency,
        })
        console.log('conversion', email)

        // @ts-ignore
        if (rewardful) {
          // @ts-ignore
          rewardful('convert', { email })
        }
      }
    },
    [],
  )

  return { trackConversion }
}
